import InputDataPanel from "./Panels/InputData";
import EstimationPanel from "./Panels/EstimationPanel";
import CalculationPanel from "./Panels/CalculationPanel";
import ModelingPanel from "./Panels/ModelingPanel";
import SpecPanel from "./Panels/SpecPanel";
import TablesPanel from "./Panels/TablesPanel";
import DataTabs from "../../PressureVessel/PressureVesselData";
import EstimationTab from "../../Tank/Tank_Estimation/Tank_Estimation";
import CalculationTab from "../../PressureVessel/calculation_tabs";

export const pvTabs = (project) => {
  return [
    {
      label: "Input Data",
      // panel: <InputDataPanel />,
      panel: <DataTabs project={project} />,
    },
    {
      label: "Estimation",
      // panel: <EstimationPanel />,
      panel: <EstimationTab />,
    },
    {
      label: "Calculation",
      // panel: <CalculationPanel />,
      panel: <CalculationTab />,
    },
    {
      label: "Modeling",
      panel: <ModelingPanel />,
    },
    {
      label: "Spec",
      panel: <SpecPanel />,
    },
    {
      label: "Tables",
      panel: <TablesPanel />,
    },
  ];
};
